import { i18n } from '@lt/localization';
import type { IPriceNoticeText } from './types';

export const getPriceNoticeText = (props: IPriceNoticeText) => {
  const { direction, isPriceChangedSignificantly } = props;

  const TEXT = {
    up: {
      title: i18n.t('checkout.priceNotice.up.title', {
        context: isPriceChangedSignificantly ? 'changed' : '',
      }),
      description: isPriceChangedSignificantly
        ? i18n.t('checkout.priceNotice.up.description')
        : '',
      isShowingHotelLink: false,
    },
    down: {
      title: i18n.t('checkout.priceNotice.down'),
      description: '',
      isShowingHotelLink: false,
    },
  };

  return TEXT[direction];
};
